import { getHttpClient } from '../../../../shared/utils/http-client.ts/index';
import { Group } from '../models/group';
import { updateGroupEndpoint } from './const';

export const updateGroup = (group: Group) => {
    return getHttpClient().post({ url: updateGroupEndpoint, data: JSON.stringify(group) });
};
